module.exports = __webpack_public_path__ + "static/footer-f3b5a062ae3c0cdffe53f5a813b34e31.png";